export default {
  name: 'localeMixin',
  computed: {
    shouldUseRtl () {
      let locale = this.$i18n.locale
      return locale === 'ar'
    }
  },
  methods: {
    setLocale (locale) {
      this.$i18n.locale = locale
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/localeMixin.js